// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__3FDS_","avatar":"styles_avatar__TEvVo","avatarImg":"styles_avatarImg__1lBEz","verified":"styles_verified__Rwc7F"};